import { useLayoutEffect } from "react";
import { useOutletContext } from "react-router-dom";
import ViewCompleteHistory from "../../../../Diathrive/src/containers/ViewCompleteHistory";

const ViewCompleteHistoryWeb = () => {
  const { setHeaderName } = useOutletContext();

  useLayoutEffect(() => {
    if (setHeaderName) setHeaderName("All Glucose Levels");
  }, [setHeaderName]);
  return <ViewCompleteHistory />;
};

export default ViewCompleteHistoryWeb;
